import React from 'react';

import { ButtonV2 } from 'components/common/ui';

import { ModalV2 } from 'components/common/modals';
import { ModalFooter } from 'components/common/modals/ModalV2';

export const DeleteConfirmationModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
}) => {
  return (
    <ModalV2
      isOpen={isOpen}
      onClose={onClose}
      title="Delete image"
      maxWidth="sm"
    >
      Are you sure you want to delete this image?
      <ModalFooter>
        <ButtonV2 variant="secondary" onClick={onClose} loading={isLoading}>
          Cancel
        </ButtonV2>
        <ButtonV2 onClick={onConfirm} autoFocus loading={isLoading}>
          Delete
        </ButtonV2>
      </ModalFooter>
    </ModalV2>
  );
};

export default DeleteConfirmationModal;
